import * as path from "path";

import { pathExists, readdir } from "fs-extra";

import { ILogger } from "../../Commons/Logging/ILogger";
import { BuildCache, FormBuildCacheOptions } from "../../FormWebpackConfiguration/CacheAssetsPlugin";
import { getLogger } from "../../Commons/Logging/StaticLogger";

import { writeResourceFile } from "./WriteResourceFile";

export async function writeFLangNormalizationFiles(
    gfv: string,
    formDirectory: string,
    resourcesDirectory: string,
    parentLogger: ILogger = getLogger(),
    buildCache?: BuildCache,
    buildCacheOptions?: FormBuildCacheOptions,
    buildCacheExist?: boolean
): Promise<void> {
    await writeResourceFile(
        "FLASHNORM",
        "ServerSide.normalize",
        path.join("normalize", `${gfv}.normalize`),
        gfv,
        formDirectory,
        resourcesDirectory,
        parentLogger,
        buildCache,
        buildCacheOptions,
        buildCacheExist
    );

    const formDistPath = path.join(formDirectory, "normalizers");
    const flangFiles = (await pathExists(formDistPath))
        ? (await readdir(formDistPath)).filter(x => path.extname(x) === ".flang")
        : [];

    for (const flangFile of flangFiles) {
        await writeResourceFile(
            "FLASHNORM",
            path.join("..", "normalizers", flangFile),
            path.join("normalize", `${gfv}.${flangFile}`),
            gfv,
            formDirectory,
            resourcesDirectory,
            parentLogger,
            buildCache,
            buildCacheOptions,
            buildCacheExist
        );
    }
}
